<template>
  <div id="app">
    <b-navbar sticky type="light" variant="light" toggleable="sm">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-form>
            <b-form-select v-model="league" :options="leagues" size="sm" />
          </b-nav-form>
          <b-nav-item-dropdown text="On/Off">
            <b-dropdown-item :to="{ name: 'wowy', params: { league: league }}">Wowy</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'wowy_combos', params: { league: league }}">Wowy Combinations</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'lineup_subunits', params: { league: league }}">Lineup Subunits</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'on_off', params: { league: league, type: 'player' }}">On/Off - Player Stats</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'on_off', params: { league: league, type: 'team' }}">On/Off - Team Stats - All Stats for Player</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'on_off', params: { league: league, type: 'stat' }}">On/Off - Team Stats - All Players for Stat</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Totals">
            <b-dropdown-item :to="{ name: 'totals', params: { league: league, type: 'player' }}">Player</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'totals', params: { league: league, type: 'team' }}">Team</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'totals', params: { league: league, type: 'opponent' }}">Opponent</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'totals', params: { league: league, type: 'lineup' }}">Lineup</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'totals', params: { league: league, type: 'lineup-opponent' }}">Lineup Opponent</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'top_results', params: { league: league, type: 'season' }}">Top Seasons</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Game Logs">
            <b-dropdown-item :to="{ name: 'game_logs', params: { league: league, type: 'player' }}">Player</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'game_logs', params: { league: league, type: 'team' }}">Team</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'game_logs', params: { league: league, type: 'opponent' }}">Opponent</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Games">
            <b-dropdown-item :to="{ name: 'games', params: { league: league }}">Final Games</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'live', params: { league: league }}">Live Games</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'possession_finder', params: { league: league }}">Possession Finder</b-nav-item>
          <b-nav-item-dropdown text="Visualizations">
            <b-dropdown-item :to="{ name: 'assist_networks', params: { league: league, type: 'team' }}">Assist Networks</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'scatter_plots', params: { league: league }}">Scatter Plots</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'year_over_year_plot', params: { league: league }}">League Year-Over-Year Plots</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'score_margin', params: { league: league }}">Team Score Margin Frequencies</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'four_factors_on_off', params: { league: league }}">Four Factors On-Off</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'player_playing_time_distribution', params: { league: league }}">Player Playing Time Distribution By Game</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'number_of_starter_stats_by_team', params: { league: league }}">Team Possessions By Number of Starters</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'team_possession_length', params: { league: league }}">Possession Length Distribution By Team</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'wowy_combo_playing_time_distribution', params: { league: league }}">Wowy Combo Playing Time Distribution By Game</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Summary Tables">
            <b-dropdown-item :to="{ name: 'team_leverage_summary', params: { league: league }}">Team Summary By Leverage</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'pace_efficiency_summary', params: { league: league }}">Pace/Efficiency</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'pace_efficiency_by_season', params: { league: league }}">League Pace/Efficiency By Season</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'score_time_summary', params: { league: league }}">Team/Lineup Stats By Time and Score</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'shot_query_summary', params: { league: league }}">Shot Query Summary</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'assist_combo_summary', params: { league: league }}">Assist Combos</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'opponent_lineup_summary', params: { league: league }}">Opponent Lineup Summary</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'shots', params: { league: league }}">Shots</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'relative_off_def_rtg', params: { league: league }}">Relative Off/Def Efficiency</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'endgame', params: { league: league }}">End Game - 2s vs 3s</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="https://tracking.pbpstats.com/">Tracking</b-nav-item>
          <b-nav-item href="https://www.patreon.com/pbpstats" target = "_blank"><img src = "https://pbpstats.s3.amazonaws.com/img/patreon.png" alt = "Patreon" border = "0"/></b-nav-item>
          <b-nav-form>
            <template>
              <vue-suggest
                placeholder="Search Players"
                :list="players"
                :filter-by-query="true">
                <div slot="suggestion-item" slot-scope="{ suggestion }">
                  <b-nav-item :to="{ name: 'season_stats', params: { league: league }, query: { EntityType: 'Player', EntityId: suggestion.id }}">{{ suggestion.title }}</b-nav-item>
                </div>
              </vue-suggest>
            </template>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
import VueSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
  name: 'app',
  components: {
    VueSuggest
  },
  data () {
    return {
      leagues: ['nba', 'gleague', 'wnba'],
      league: 'nba',
      players: []
    }
  },
  mounted () {
    let goatCounter = document.createElement('script')
    goatCounter.setAttribute('data-goatcounter', 'https://pbpstats.goatcounter.com/count')
    goatCounter.async = true
    goatCounter.src = '//gc.zgo.at/count.js'
    document.head.appendChild(goatCounter)
  },
  created () {
    if (this.$parent.$route !== undefined) {
      if (this.$parent.$route.params.league !== undefined) {
        this.league = this.$parent.$route.params.league
      }
    }
    this.getPlayers()
    window.document.title = 'PBP Stats'
  },
  watch: {
    'league': 'getPlayers',
    '$route': 'pageView'
  },
  methods: {
    getPlayers () {
      this.players = []
      axios.get(process.env.API_BASE_URL + 'get-all-players-for-league/' + this.league)
        .then((response) => {
          this.player_ids = Object.keys(response.data.players)
          this.players = []
          this.player_selected = undefined
          this.player_ids.forEach((playerId) => {
            this.players.push({'id': playerId, 'title': response.data.players[playerId]})
          })
        }, (error) => {
          this.error = error
        })
    },
    pageView () {
      let goatCounter = document.createElement('script')
      goatCounter.setAttribute('data-goatcounter', 'https://pbpstats.goatcounter.com/count')
      goatCounter.async = true
      goatCounter.src = '//gc.zgo.at/count.js'
      document.head.appendChild(goatCounter)
    }
  }
}
</script>

<style>

#app {
    width: 100%;
}

#games-containier {
    width: 50%;
}

#top-results-table-container {
  max-width: 750px;
}

.border-padding {
  border-width: 1px;
  padding: 4px;
}

td {
  text-align: left;
  font-size: .7rem;
}

th {
  font-size: .7rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue